<template>
  <div :class="$style['page-container']">
    <!-- 左侧导航 -->
    <div :class="$style['page--left']">
      <pt-side-component-nav></pt-side-component-nav>
    </div>
    <!-- 右侧区域 -->
    <div :class="$style['page--right']">
      <pt-com-header></pt-com-header>
      <div :class="[$style['page__content']]">
        <div :class="[$style['page__content-box'],'detail-specific']">
          <wt-view :class="[$style['page__content__view'],'shadow']"></wt-view>
        </div>

        <div :class="$style['page__footer']" v-if="showFooter">
          <p> <a target="_blank" href="https://beian.miit.gov.cn">{{beian}}</a></p>
          <p>信息产业部备案管理系统：<a target="_blank" href="https://beian.miit.gov.cn">https://beian.miit.gov.cn</a></p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ptComHeader from 'cps/pt-com-header'
// import ptPageBreadcrumb from 'cps/base/pt-page-breadcrumb'
import ptSideComponentNav from 'cps/pt-side-component-nav'
// import { updateBreadcrumb } from '@/utils/breadcrumb'
export default {
  name: 'component-nav',
  components: {
    ptComHeader,
    ptSideComponentNav
    // ptPageBreadcrumb
  },
  //   watch: {
  //     '$store.state.menuList': {
  //       handler: function (val) {
  //         this.menuList = val
  //       },
  //       immediate: true
  //     }
  //   },
  computed: {
    isIcp () {
      return this.$store.state.saasConfig.tenant === 'guardianhealth'
    },
    // 是否显示footer备案信息
    showFooter () {
      return this.$route.name === 'home'
    },
    beian () {
      return localStorage.getItem('ForTheRecord')
    }
    // currentRotute () {
    //   return this.$route
    // },
    // isEdit () {
    //   return this.$route.params && this.$route.params.isEdit && this.$route.params.isEdit === 'true'
    // },
    // newText () {
    //   return this.$route.meta && this.$route.meta.newText
    // },
    // isForm () {
    //   return this.$route.meta && this.$route.meta.isForm
    // },
    // currentBreadcrumbs () {
    //   return updateBreadcrumb(this.currentRotute, this.menuList, this.isForm, this.isEdit, this.newText)
    // }
  },
  data () {
    return {
      menuList: []
    }
  },
  created () {
  }
}
</script>
<style module lang="less">
.page-container{
  height: 100%;
  display: flex;

}
.page--left{
  width: 150px;
  background-color:#F0F0F0;
  overflow-y: auto;
  :global{
    .pt-side-component--top{
      width: 150px;
    }
  }
}
.page--right{
  flex:1;
  overflow-x: hidden;
  position: relative;
}
.page__content{
  position: relative;
  margin-top:60PX;
  min-height: ~"calc(100% - 60px)";
  overflow-y:auto;
}
.page__content-box{
  padding:25PX;
  min-height: ~"calc(100% - 60px)";
}
.page__content__view{
  // height: 100%;
  // min-height:90vh;
  border-radius: 10px;
  padding:40px 30PX 30PX;
  z-index:2;
}
.page__footer{
  // position: absolute;
  // left: 0;
  width: 100%;
  padding: 10px 0;
  background-color: #E7E7E6;
  color:#333;
  text-align: center;
  p{
    margin: 0;
    line-height: 26px;
  }
}
</style>
